export const YOUTUBE = 'youtube';
export const BRIGHT_COVE = 'brightcove';
